import React from 'react';
import { Box, Typography, Chip, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { UserInterface } from 'services/regions';

interface SupervisorsSectionProps {
  supervisors: UserInterface[];
  loading?: boolean;
}

export const SupervisorsSection = ({
  supervisors,
  loading = false,
}: SupervisorsSectionProps) => {
  const classes = useStyles();

  return (
    <Box width="100%" display="flex" flexDirection="column" mt={3} mx={2}>
      <Typography variant="body1" gutterBottom className={classes.bold}>
        Regional Managers
      </Typography>
      <Box display="flex" justifyContent="space-between">
        <Box>
          {loading ? (
            <CircularProgress size={20} />
          ) : (
            supervisors.map(supervisor => (
              <Chip
                key={supervisor.id}
                className={classes.rightMargin}
                label={`${supervisor.firstName} ${supervisor.lastName}`}
              />
            ))
          )}
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles({
  bold: {
    fontWeight: 'bold',
  },
  rightMargin: {
    marginRight: '5px',
  },
});
